class SFileField extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const input = this.querySelector('input[type="file"]');
    const output = this.querySelector('[data-file-name]');
    if (!input || !output) return;

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      output.textContent = file ? file.name : output.dataset.empty || '';
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-file-field')) {
  customElements.define('s-file-field', SFileField);
}
